import React, { useState } from 'react';
import {
  Box,
  Typography,
  ToggleButton,
  ToggleButtonGroup,
  useMediaQuery,
  useTheme
} from '@mui/material';
import Dashboard from './Dashboard';
import KPITimeseries from './KPITimeseries';

const Home = ({ showSnackbar, isActive, homeRefreshKey }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [view, setView] = useState('dashboard'); // 'dashboard' | 'timeseries'

  const handleViewChange = (event, newView) => {
    if (newView !== null) {
      setView(newView);
    }
  };

  return (
    <Box>
      <Box 
        display="flex" 
        flexDirection={isMobile ? 'column' : 'row'}
        justifyContent="space-between" 
        alignItems={isMobile ? 'flex-start' : 'center'} 
        sx={{ mb: { xs: 2, sm: 3 }, gap: { xs: 2, sm: 0 } }}
      >
        <Typography variant={isMobile ? 'h5' : 'h4'}>Home</Typography>
        <ToggleButtonGroup
          value={view}
          exclusive
          onChange={handleViewChange}
          aria-label="vista"
          fullWidth={isMobile}
          size={isMobile ? 'small' : 'medium'}
        >
          <ToggleButton value="dashboard" aria-label="dashboard">
            Dashboard
          </ToggleButton>
          <ToggleButton value="timeseries" aria-label="timeseries">
            Timeseries KPIs
          </ToggleButton>
        </ToggleButtonGroup>
      </Box>
      {view === 'dashboard' ? (
        <Dashboard showSnackbar={showSnackbar} isActive={isActive} homeRefreshKey={homeRefreshKey} />
      ) : (
        <KPITimeseries showSnackbar={showSnackbar} />
      )}
    </Box>
  );
};

export default Home;
